import { OPEN_HR_BOT_DRAWER, CLOSE_HR_BOT_DRAWER } from './action';

const initialState = {
  isOpen: false,
};

const hrBotDrawer = (state = initialState, { type }) => {
  switch (type) {
    case OPEN_HR_BOT_DRAWER:
      return {
        ...state,
        isOpen: true,
      };

    case CLOSE_HR_BOT_DRAWER:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
};

export default hrBotDrawer;
